<template>
  <div>
    <sui-grid>
      <sui-grid-column :width="6" :centered="true">
        <sui-message header="Access restricted">
          <sui-message-content>
            Please sign-in.
            <br>
            <sui-button content="Sign in" icon="sign in alternate icon" @click="login()" primary/>
          </sui-message-content>
        </sui-message>
      </sui-grid-column>
    </sui-grid>
  </div>
</template>
<script>
import { login } from "../services/authentication";
export default {
  name: "Authorize",
  methods: {
    login() {
      login();
    }
  }
};
</script>

<style lang="scss" scoped>
div.message {
  margin-top: 4rem !important;
}
button {
  margin-top: 1rem !important;
}
</style>